module.exports = __webpack_public_path__ + "static/daniela-0cb8e8aa7fbbbafd135308c2fd0cf4f0.jpg";